@if (viewIsInit) {
  <span>
    <ng-container *ngTemplateOutlet="getCurrentTemplate();context: {width: width, height: height}"></ng-container>
  </span>
}

<ng-template #list let-width="width" let-height="height">
  <svg viewBox="0 0 24 24" [attr.width]="width" [attr.height]="height" stroke="currentColor" stroke-width="2"
    fill="none" stroke-linecap="round" stroke-linejoin="round">
    <line x1="8" y1="6" x2="21" y2="6"></line>
    <line x1="8" y1="12" x2="21" y2="12"></line>
    <line x1="8" y1="18" x2="21" y2="18"></line>
    <line x1="3" y1="6" x2="3.01" y2="6"></line>
    <line x1="3" y1="12" x2="3.01" y2="12"></line>
    <line x1="3" y1="18" x2="3.01" y2="18"></line>
  </svg>
</ng-template>

<ng-template #folder let-width="width" let-height="height">
  <svg viewBox="0 0 24 24" [attr.width]="width" [attr.height]="height" stroke="currentColor" stroke-width="2"
    fill="none" stroke-linecap="round" stroke-linejoin="round">
    <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path>
  </svg>
</ng-template>

<ng-template #logout>
  <svg viewBox="0 0 24 24" [attr.width]="width" [attr.height]="height" stroke="currentColor" stroke-width="2"
    fill="none" stroke-linecap="round" stroke-linejoin="round" class="css-i6dzq1">
    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
    <polyline points="16 17 21 12 16 7"></polyline>
    <line x1="21" y1="12" x2="9" y2="12"></line>
  </svg>
</ng-template>

<ng-template #cast>
  <svg viewBox="0 0 24 24" [attr.width]="width" [attr.height]="height" stroke="currentColor" stroke-width="2"
    fill="none" stroke-linecap="round" stroke-linejoin="round" class="css-i6dzq1">
    <path
      d="M2 16.1A5 5 0 0 1 5.9 20M2 12.05A9 9 0 0 1 9.95 20M2 8V6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-6">
    </path>
    <line x1="2" y1="20" x2="2.01" y2="20"></line>
  </svg>
</ng-template>

<ng-template #shoppingbag>
  <svg viewBox="0 0 24 24" [attr.width]="width" [attr.height]="height" stroke="currentColor" stroke-width="2"
    fill="none" stroke-linecap="round" stroke-linejoin="round" class="css-i6dzq1">
    <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path>
    <line x1="3" y1="6" x2="21" y2="6"></line>
    <path d="M16 10a4 4 0 0 1-8 0"></path>
  </svg>
</ng-template>

<ng-template #bell>
  <svg viewBox="0 0 24 24" [attr.width]="width" [attr.height]="height" stroke="currentColor" stroke-width="2"
    fill="none" stroke-linecap="round" stroke-linejoin="round" class="css-i6dzq1">
    <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
    <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
  </svg>
</ng-template>

<ng-template #users>
  <svg viewBox="0 0 24 24" [attr.width]="width" [attr.height]="height" stroke="currentColor" stroke-width="2"
    fill="none" stroke-linecap="round" stroke-linejoin="round" class="css-i6dzq1">
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
    <circle cx="9" cy="7" r="4"></circle>
    <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
    <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
  </svg>
</ng-template>

<ng-template #info>
  <svg viewBox="0 0 24 24" [attr.width]="width" [attr.height]="height" stroke="currentColor" stroke-width="2" fill="none"
    stroke-linecap="round" stroke-linejoin="round" class="css-i6dzq1">
    <circle cx="12" cy="12" r="10"></circle>
    <line x1="12" y1="16" x2="12" y2="12"></line>
    <line x1="12" y1="8" x2="12.01" y2="8"></line>
  </svg>
</ng-template>